import { memo, useMemo } from 'react';

import { ErrorBlock } from './ErrorBlock.tsx';
import File from './File.tsx';
import type { FileUploadState } from './types.ts';

interface MultiFileListProps {
  handleReset?: () => void;
  tryAnotherText: string;
  filesState: FileUploadState[];
  errorBlockTitle?: string;
}

export const MultiFileList = memo(function MultiFileList({ filesState, tryAnotherText, handleReset, errorBlockTitle }: MultiFileListProps) {
  const errors = useMemo<string[]>(
    () => filesState.reduce<string[]>((acc, item) => (item.error ? [...acc, `${item.fileName} - ${item.error}`] : acc), []),
    [filesState],
  );

  if (errors.length) {
    return <ErrorBlock errors={errors} onResetClick={handleReset} errorBlockTitle={errorBlockTitle} tryAgainText={tryAnotherText} />;
  }

  return (
    <>
      {filesState.map((file) => (
        <File
          key={file.uniqueIdentifier}
          fileName={file.fileName}
          progress={file.progress}
          tryAnotherText={tryAnotherText}
          isUploading={file.isUploading}
          error={file.error}
          success={file.success}
        />
      ))}
    </>
  );
});
